import notifications from 'notifications';
import * as net from 'util/Net';

import {ESignatureInfo} from './ReviewConstants';

// Keep in sync with esignature.py
export const SIGNATURE_TYPE_AZURE_AD = 'AZURE_AD';
export const SIGNATURE_TYPE_OKTA = 'OKTA';
export const SIGNATURE_TYPE_SAML = 'SAML';

export interface EsignatureConfig {
  type: typeof SIGNATURE_TYPE_AZURE_AD | typeof SIGNATURE_TYPE_OKTA | typeof SIGNATURE_TYPE_SAML;
  oktaHost?: string;
}

export interface OktaAuthResponse {
  status: string;
  sessionToken: string;
}

export default function createEsignature(
  username: string,
  password: string,
  esignatureConfig: EsignatureConfig
): Promise<ESignatureInfo> {
  switch (esignatureConfig.type) {
    case SIGNATURE_TYPE_OKTA:
      return Promise.resolve(
        net.postJSON({
          url: `${esignatureConfig.oktaHost}/api/v1/authn`,
          data: {
            username,
            password,
            options: {
              multiOptionalFactorEnroll: false,
              warnBeforePasswordExpired: false,
            },
          },
        })
      )
        .catch(() => {
          throw new Error(`Error connecting to ${esignatureConfig.oktaHost}`);
        })
        .then(({status, sessionToken}: OktaAuthResponse) => {
          if (status === 'MFA_REQUIRED') {
            notifications.error('Validation requires MFA and is not currently supported');
            throw new Error('Error due to MFA not supported');
          }
          if (status !== 'SUCCESS') {
            throw new Error(`Auth had success status code but status in response was ${status}`);
          }
          return {
            signature: sessionToken,
            signatureType: SIGNATURE_TYPE_OKTA,
          };
        });
    default:
      throw new Error(`Unexpected esignature type: ${esignatureConfig.type}`);
  }
}
